import React from 'react';
import { Badge, Group, Text, ThemeIcon } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';

interface ChangeItemProps {
  label: string;
  before: string;
  after: string;
  red: string;
  green: string;
  chip?: 'Changed' | 'Added' | 'Removed' | 'Modified';
  icon?: React.ReactNode;
  iconColor?: string;
}

export const ChangeItem: React.FC<ChangeItemProps> = ({
  label,
  before,
  after,
  chip = 'Changed',
  icon,
  iconColor = 'blue',
}) => {
  const showBefore = chip !== 'Added';

  return (
    <Group gap="sm" py={6} align="flex-start" data-testid="change-item">
      <ThemeIcon size={24} radius="sm" variant="light" color={iconColor}>
        {icon}
      </ThemeIcon>
      <Text fw={600} w={150} maw="100%" lh={1.4}>
        {label}
      </Text>
      <Group gap="xs" style={{ flex: '1 1 260px' }}>
        {showBefore && (
          <>
            <Badge
              variant="light"
              color={chip === 'Removed' ? 'blue' : 'gray'}
              radius="xl"
              maw={240}
              title={before || 'None'}
              styles={{
                label: { overflow: 'hidden', textOverflow: 'ellipsis' },
              }}
            >
              {before || 'None'}
            </Badge>
            <IconArrowRight size={16} color="gray" />
          </>
        )}
        <Badge
          variant="light"
          color={
            chip === 'Removed' ? 'gray' : chip === 'Added' ? 'green' : 'blue'
          }
          radius="xl"
          maw={240}
          title={after || (chip === 'Removed' ? 'Removed' : 'Created')}
          styles={{ label: { overflow: 'hidden', textOverflow: 'ellipsis' } }}
        >
          {after || (chip === 'Removed' ? 'Removed' : 'Created')}
        </Badge>
      </Group>
    </Group>
  );
};
